/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Event_Group_Linked_Group_NoneInputs */

const en_merge_event_group_linked_group_none = /** @type {(inputs: Merge_Event_Group_Linked_Group_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None`)
};

const fr_merge_event_group_linked_group_none = /** @type {(inputs: Merge_Event_Group_Linked_Group_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun`)
};

const de_merge_event_group_linked_group_none = /** @type {(inputs: Merge_Event_Group_Linked_Group_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keiner`)
};

const it_merge_event_group_linked_group_none = /** @type {(inputs: Merge_Event_Group_Linked_Group_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuno`)
};

const ru_merge_event_group_linked_group_none = /** @type {(inputs: Merge_Event_Group_Linked_Group_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Никто`)
};

const es_merge_event_group_linked_group_none = /** @type {(inputs: Merge_Event_Group_Linked_Group_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ninguno`)
};

const zh_cn2_merge_event_group_linked_group_none = /** @type {(inputs: Merge_Event_Group_Linked_Group_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有任何`)
};

const ja_merge_event_group_linked_group_none = /** @type {(inputs: Merge_Event_Group_Linked_Group_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なし`)
};

const hi_merge_event_group_linked_group_none = /** @type {(inputs: Merge_Event_Group_Linked_Group_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई नहीं`)
};

const pt_pt2_merge_event_group_linked_group_none = /** @type {(inputs: Merge_Event_Group_Linked_Group_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum`)
};

/**
* | output |
* | --- |
* | "None" |
*
* @param {Merge_Event_Group_Linked_Group_NoneInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_event_group_linked_group_none = /** @type {((inputs?: Merge_Event_Group_Linked_Group_NoneInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Event_Group_Linked_Group_NoneInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_merge_event_group_linked_group_none(inputs)
	if (locale === "de") return de_merge_event_group_linked_group_none(inputs)
	if (locale === "it") return it_merge_event_group_linked_group_none(inputs)
	if (locale === "ru") return ru_merge_event_group_linked_group_none(inputs)
	if (locale === "es") return es_merge_event_group_linked_group_none(inputs)
	if (locale === "zh-CN") return zh_cn2_merge_event_group_linked_group_none(inputs)
	if (locale === "ja") return ja_merge_event_group_linked_group_none(inputs)
	if (locale === "hi") return hi_merge_event_group_linked_group_none(inputs)
	if (locale === "pt-PT") return pt_pt2_merge_event_group_linked_group_none(inputs)
	return en_merge_event_group_linked_group_none(inputs)
});